import { ACCEPTED_FILE_EXTENSIONS, MAX_IMPORT_FILE_SIZE_BYTES } from '../constants';
import type { ImportRejection } from '../types';

export const validateImportFile = (file: File): ImportRejection | undefined => {
  const name = file.name.toLowerCase();

  if (!ACCEPTED_FILE_EXTENSIONS.some((extension) => name.endsWith(extension))) {
    return 'unsupportedType';
  }

  if (file.size > MAX_IMPORT_FILE_SIZE_BYTES) {
    return 'tooLarge';
  }

  return undefined;
};
